import { HttpContext, HttpParams } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {Observable, map} from 'rxjs';
import {IS_EXPECTED_ABSENCE_404} from '@constants/http-context';
import {CssOverwrites, CUSTOM_CSS_WIDGET_TYPE} from '../../models/css-overwrites.model';
import {HttpClientService} from '../utils/http-client.service';
import {CustomEventService} from './custom-event.service';
import {WidgetService} from './widget.service';

@Injectable({
  providedIn: 'root'
})
export class CssOverwriteService {

  /** Set by SmartWidgetElementComponent when `template` attribute is present. */
  templateUuidFromAttributes?: string;

  constructor(
    private http: HttpClientService,
    private widgetService: WidgetService,
    private route: ActivatedRoute,
    private customEventService: CustomEventService
  ) { }

  getCssOverwrites(): Observable<CssOverwrites> {
    // 404 = the widget simply has no active CSS overwrite — an expected outcome on most
    // widgets, so the interceptor is told not to error-log it (the caller ignores it too).
    return this.http.get(
      `css_overwrites/active?type=${CUSTOM_CSS_WIDGET_TYPE.smart_widget}&widget_uuid=${this.widgetService.widgetConf.widget_uuid}`,
      { context: new HttpContext().set(IS_EXPECTED_ABSENCE_404, true) }
    );
  }

  getCssOverwriteUsingUuid(uuid: string, isPreview = false): Observable<CssOverwrites> {
    let params = new HttpParams();
    if (isPreview) { params = params.append('preview', true); }

    return this.http.get('css_overwrites/' + uuid, { params })
      .pipe(
        map(result => {
          if (result?.errors !== undefined) {
            return null;
          }
          return result;
        })
      );
  }

  checkForCssTemplateOrActiveCss(): void {
    // WC mode: read template from attributes set by the element wrapper, not from the URL.
    if (this.widgetService.isWebComponentMode) {
      if (this.templateUuidFromAttributes) {
        this.customEventService.cssOverwriteTemplateUuid.emit({
          templateUuid: this.templateUuidFromAttributes
        });
      } else {
        this.customEventService.cssOverwriteTemplateUuid.emit();
      }
      return;
    }

    this.route.queryParams.subscribe({
      next: (result: Params) => {
        if (result?.template) {
          this.customEventService.cssOverwriteTemplateUuid.emit({
            templateUuid: result?.template
          });
        } else {
          this.customEventService.cssOverwriteTemplateUuid.emit();
        }
      }
    });
  }
}
